import styled from 'styled-components';
// @ts-ignore TODO: migrate to react-router-dom
import { Link } from 'react-router';

import { Box } from '../Box';
import { Text } from '../Text';
import * as Theme from '../styles/themeGetters';
import { ColorKeys as Color } from '../styles/themes';

export const NavBarSectionTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
`;

export const NavBarGroupTitle = styled(Text)`
  font-size: 10px;
  font-weight: bold;
  margin: 15px 0 0;
  padding-left: 8px;
  text-transform: uppercase;
`;

export const NavBarSectionText = styled(Text).withConfig({
  shouldForwardProp: prop => !['textColor'].includes(prop as string),
})<{ textColor?: Color }>`
  font-size: 14px;
  min-height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${({ textColor }) => Theme.getColor(textColor || 'black')};
`;

export const NavBarSectionLink = styled(Link).withConfig({
  shouldForwardProp: prop =>
    !['textColor', 'hoverBg', 'activeBg', 'activeBorderColor'].includes(
      prop as string
    ),
})<{
  textColor?: Color;
  hoverBg?: Color;
  activeBg?: Color;
  activeBorderColor?: Color;
}>`
  text-decoration: none;
  border-radius: 4px;
  height: 32px;
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 0 ${Theme.getBaseUnit(2)};
  color: ${({ textColor }) => Theme.getColor(textColor || 'black')};

  /* Left-align the Anchor elem to the buttons in the Navbar,
   * which use the Baukasten Button (which has a 1px border). */
  border: 1px solid transparent;

  &:hover {
    background-color: ${({ hoverBg }) =>
      Theme.getColor(hoverBg || 'grey-light-50')};
  }

  &.active {
    background-color: ${({ activeBg, hoverBg }) =>
      Theme.getColor(activeBg || hoverBg || 'grey-light-50')};

    ${NavBarSectionText} {
      color: ${({ textColor }) => Theme.getColor(textColor || 'navy')};
      font-weight: 700;
    }
  }

  > svg {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
  }
`;

export const NavBarSectionLinkWithAvatar = styled(NavBarSectionLink)`
  padding-left: 7px;
`;

export const NavBarSectionGroup = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
  }
`;

export const NavBarSectionIcon = styled.span`
  width: 28px;
  height: 28px;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavBarBoxAsLink = styled(Box)`
  border-radius: 4px;
  height: 32px;
  display: flex;
  cursor: pointer;
  gap: 4px;
  align-items: center;
  padding: ${Theme.getBaseUnit(2)};
  color: ${Theme.getColor('black')};

  &:hover {
    background-color: ${Theme.getColor('grey-light-50')};
  }

  &.active {
    background-color: ${Theme.getColor('grey-light-50')};
  }
`;

export const NavBarSearchResultLink = styled(NavBarSectionLink)`
  height: auto;
  min-height: 32px;
`;

export const NavBarSectionTextCount = styled(Text)`
  font-size: 14px;
  color: ${Theme.getColor('grey-dark')};
`;

export const NavBarSectionAnchor = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  user-select: none;
  padding: 2px ${Theme.getBaseUnit(2)};
  border-radius: 4px;

  &:hover {
    background-color: ${Theme.getColor('grey-light-50')};
  }
`;
